(function () {
    const carousels = document.querySelectorAll('[data-service-carousel]');

    carousels.forEach((carousel) => {
        const slides = Array.from(carousel.querySelectorAll('[data-service-slide]'));
        const dots = Array.from(carousel.querySelectorAll('[data-service-dot]'));
        const status = carousel.querySelector('[data-service-status]');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const slideTitles = ['BlockThreat Enterprise', 'Sponsor BlockThreat', 'BlockThreat Community'];
        const rotationDelay = 7000;
        let activeIndex = 0;
        let timer;

        if (slides.length < 2) {
            return;
        }

        const stopTimer = () => {
            window.clearTimeout(timer);
        };

        const showSlide = (nextIndex, announce) => {
            activeIndex = (nextIndex + slides.length) % slides.length;

            slides.forEach((slide, index) => {
                const isActive = index === activeIndex;
                slide.classList.toggle('is-active', isActive);
                slide.setAttribute('aria-hidden', String(!isActive));
                if (isActive) {
                    slide.removeAttribute('tabindex');
                } else {
                    slide.setAttribute('tabindex', '-1');
                }
            });

            dots.forEach((dot, index) => {
                const isActive = index === activeIndex;
                dot.classList.toggle('is-active', isActive);
                dot.setAttribute('aria-current', String(isActive));
            });

            if (announce && status) {
                status.textContent = `Showing ${activeIndex + 1} of ${slides.length}: ${slideTitles[activeIndex]}`;
            }
        };

        const scheduleNext = () => {
            stopTimer();
            if (reducedMotion.matches || document.hidden) {
                return;
            }
            timer = window.setTimeout(() => {
                showSlide(activeIndex + 1, false);
                scheduleNext();
            }, rotationDelay);
        };

        dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                showSlide(index, true);
                scheduleNext();
            });
        });

        carousel.addEventListener('mouseenter', stopTimer);
        carousel.addEventListener('mouseleave', scheduleNext);
        carousel.addEventListener('focusin', stopTimer);
        carousel.addEventListener('focusout', () => {
            window.setTimeout(() => {
                if (!carousel.contains(document.activeElement)) {
                    scheduleNext();
                }
            });
        });

        carousel.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
                return;
            }
            event.preventDefault();
            showSlide(activeIndex + (event.key === 'ArrowRight' ? 1 : -1), true);
            scheduleNext();
        });

        document.addEventListener('visibilitychange', scheduleNext);
        reducedMotion.addEventListener('change', scheduleNext);
        scheduleNext();
    });
}());
